import { useQuery } from '@tanstack/react-query'
import { desilApi } from '../lib/client'
import { ApiResponse, DesilData } from '../../../shared-lib/types'

export function useLatestDesil() {
    return useQuery<ApiResponse<DesilData | null>>({
        queryKey: ['desil', 'latest'],
        queryFn: async () => {
            try {
                return await desilApi.getLatestDesil()
            } catch (error) {
                // Create structured error response
                const errorResponse: ApiResponse<DesilData | null> = {
                    status: "error",
                    message: error instanceof Error ? error.message : "Gagal mengambil data desil terbaru",
                    data: null
                }
                
                console.error('Error fetching latest desil:', error)
                throw errorResponse
            }
        },
        staleTime: 5 * 60 * 1000, // 5 minutes
        retry: 3,
    })
}